// frontend/src/hooks/usePermission.js

import { useAuth } from '../context/AuthContext';

const usePermission = (permission) => {
    const { auth } = useAuth();
    if (!auth) return false;
    return auth.user.permissions.includes(permission);
};

export default usePermission;
